import queryString from 'querystring'
import { useEffect } from 'react'
import { STORAGE } from 'project-config/constants'
import { useGlobalStore } from '@/store/global/global-store'
import { Cookie } from 'project-config/utils'
import { goToMainRoute } from 'project-config/utils/env'
import { HttpCode } from 'project-config/services/request/http-code'
import { useModalStore } from '@/store/modal/modal-store'
import { NeedUserLoginModal } from '@/components/modal/need-user-login-modal'

export function useAuth() {
  const { userInfo, fetchUserData } = useGlobalStore()
  const { showGlobalModal } = useModalStore()
  const searchParams = queryString.parse(window.location.search.substring(1))
  const userKey = searchParams.rayvision_token as string
  const raySyncUserKey = searchParams.raySyncUserKey as string
  const channel = searchParams.channel as string
  const platform = searchParams.platform as string
  const lang = searchParams.lang as string
  const custom = searchParams.custom as string

  const handleAuth = async () => {
    const { data, code } = await fetchUserData()
    if (code === HttpCode.NeedUserLogin || code === HttpCode.NeedUserLogin2) {
      showGlobalModal({
        type: 'blank',
        render: <NeedUserLoginModal />,
      })
      return
    }
    if (!data && code !== 722 && code !== 840) {
      goToMainRoute()
    }
  }

  const handleAuthWithToken = async (token: string) => {
    if (custom) {
      localStorage.setItem(STORAGE.USER_KEY, token)
      localStorage.setItem(STORAGE.CUSTOM, `${custom}|${userKey}`)
      sessionStorage.setItem(STORAGE.USER_KEY, token)
    }
    const { code } = await fetchUserData({
      userKey: token,
    })
    if (code === 200) {
      // userInfo接口成功后，删除sessionStorage中的userKey
      sessionStorage.removeItem(STORAGE.USER_KEY)
      // delete searchParams.rayvision_token
      // delete searchParams.platform
      // const search = queryString.stringify(searchParams)
      // navigateToLegacy(`${window.location.pathname}?${search}`)
    } else {
      // goToMainRoute()
    }
  }

  const init = async () => {
    if (userInfo || ['/start', '/sso'].includes(window.location.pathname)) {
      if (['account', 'account-pre'].some((i) => location.hostname.includes(i))) {
        // goToMainRoute(false)
      }
      return
    }
    if (lang) {
      Cookie.setCookie(STORAGE.LANGUAGE_FLAG, lang === 'zh_CN' ? '0' : '1')
    }
    if (raySyncUserKey) {
      localStorage.setItem(
        STORAGE.RAY_SYNC_USER_KEY,
        `${raySyncUserKey}|${channel || 3}|${platform || 4}`,
      )
    }
    if (userKey) {
      await handleAuthWithToken(userKey).catch(console.trace)
    } else {
      await handleAuth().catch(console.trace)
    }
  }

  useEffect(() => {
    init().catch(console.trace)
  }, [userInfo, fetchUserData])
}
